import {Component, Element, Listen, State, Event, EventEmitter, Method, h, Prop} from '@stencil/core';
import { i18n } from '../../utils/I18n';
import { NjPassangers } from '../nj-passangers/nj-passangers';
import {passengersAreValid} from "../nj-passangers/passanger-utils";

@Component({
  tag: 'nj-passanger-field',
  styleUrl: 'nj-passanger-field.scss',
  shadow: true,
})
export class NjPassangerField {
  passangerEl: NjPassangers;
  input: HTMLInputElement;

  @Element() el: HTMLElement;
  @Prop() showValidation: boolean;
  @State() inputValue: string;
  @State() passangers: any[];
  @State() valid: boolean;
  @State() isOpen = false;
  @Event() datefieldActive: EventEmitter;

  componentWillLoad() {
      this.valid = passengersAreValid();
  }

  componentDidLoad() {
    this.passangerEl = this.el.shadowRoot.querySelector('nj-passangers') as any;
    this.input = this.el.shadowRoot.querySelector('input');
  }
  @Event() formDataChanged: EventEmitter;
	formDataChangedHandler(firstChange?:boolean) {
	//	console.log('trigger formDataChanged');
        this.valid = passengersAreValid();
		this.formDataChanged.emit({
			name: "passangers",
			value: this.passangers,
			valid: this.valid,
			firstChange: firstChange
		});
	}
  @Listen('click', { target: 'window' })
  async onBodyClick() {
    if (await this.passangerEl.isVisible()) {
      this.formDataChangedHandler();
      this.passangerEl.hide();
      this.isOpen = false;
    }
  }

  @Listen('keydown')
  async onKeydown(event: KeyboardEvent) {
    if (event.key === 'Esc' || event.key === 'Escape') {
			this.passangerEl.hide();
      this.el.focus();
      this.isOpen = false;
		}
  }

  @Listen('passangerChanged')
  onPassangerChange(event) {
   // console.log(event)
    this.passangers = event.detail;
  }

  @Listen('passangerTextChanged')
  onPassangerTextChange(event) {
    this.inputValue = event.detail;
  }

  @Listen('datefieldActive', { target: 'window' })
  datefieldActiveHandler(event: CustomEvent) {
    event.stopPropagation();
    if (event.detail != 'passengers') {
      this.formDataChangedHandler();
      this.passangerEl.hide();
      this.isOpen = false;
    }
  }

  @Method()
  async getPassangers(): Promise<any> {
    return Promise.resolve(this.passangers);
  }

  @Method()
  async setFocus() {
   this.el.shadowRoot.querySelector('input').focus();
  }

  async onFieldClick(e: Event) {
    e.stopPropagation();
    e.preventDefault();
    this.datefieldActive.emit('passengers');
    let isVisible = await this.passangerEl.isVisible();

    if (!this.input.classList.contains('focus')) {
      if (!isVisible) {
        this.passangerEl.show();
        this.isOpen = true;
      } else {
        this.formDataChangedHandler();
        this.passangerEl.hide();
        this.isOpen = false;
      }
    }

	  this.input.classList.remove('focus')
  }

  onMouseLeave(e: Event) {
    e.stopPropagation();
    //	this.passangerEl.hide();
  }

  onFieldFocus(e: Event) {
    this.input.classList.add('focus');
    e.stopPropagation();
    e.preventDefault();
    this.datefieldActive.emit('passengers');
    this.passangerEl.show();
    this.isOpen = true;
    var self = this
    setTimeout(function(){
      self.input.classList.remove('focus')
    },400)
  }

  onFieldBlur() {
    this.input.classList.remove('focus');
    this.formDataChangedHandler();
  }

  render() {
    return (
      <div  class={{
          "nj-passanger": true,
          "nj-passanger-field--invalid": this.showValidation && !this.valid,
      }} onMouseLeave={(e: Event) => this.onMouseLeave(e)}>
        <div class="nj-passanger-field" id="nj-passanger-field" >
          <label htmlFor="nj-from-to-passanger">{i18n.getMessage('passengerField.numberOfPassengers')}</label>
          <input
            type="text"
            id="nj-from-to-passanger"
            name="nj-from-to-passanger"
            onFocus={(e: Event) => this.onFieldFocus(e)}
            onBlur={() => this.onFieldBlur()}
			      onClick={(e: Event) => this.onFieldClick(e)}
            value={this.inputValue}
            readonly={true}
            aria-expanded={this.isOpen ? 'true' : 'false'}
            aria-controls="nj-passangers-dropdown"
          />
          <button tabindex="-1" aria-hidden="true" onClick={(e: Event) => this.onFieldClick(e)}>
            <span>{i18n.getMessage('passengerField.edit')}</span>
            <passengers-icon/>
          </button>
        </div>
        {this.showValidation && !this.valid ? <div class="validation-text" role='alert' aria-live='assertive'>{i18n.getMessage('passengers.invalid')}</div> : null}
        <nj-passangers id="nj-passangers-dropdown" class="js-nj-passangers" />
      </div>
    );
  }
}
